import { useMemo } from "react"
import { formatDate } from "date-fns"
import { useWaitingRoomSearchContext } from "@/modules/waiting-room/contexts/waiting-room-filters-context"
import { WaitingRoomAppointments } from "@/modules/waiting-room/services/WaitingRoomAppointmentsQuery"

export const useHandleSearchAppointment = (waitingRoomAppointments: WaitingRoomAppointments) => {
  const searchValue = useWaitingRoomSearchContext((state) => state.searchValue)

  const appointments = useMemo(() => {
    if (!searchValue) return waitingRoomAppointments

    const searchTerms = searchValue
      .split(/\s+/)
      .map((term) => term.trim().toLowerCase())
      .filter((term) => term.length > 0)

    if (searchTerms.length === 0) return waitingRoomAppointments

    return waitingRoomAppointments.map((slot) => ({
      ...slot,
      slots: slot.slots.map((timeSlot) => ({
        ...timeSlot,
        appointments: timeSlot.appointments.filter((appointment) => {
          const { patient, reason, appointmentId, id } = appointment.appointment

          const searchableFields = [
            patient?.patientId,
            patient?.id,
            patient?.displayId?.toString(),
            patient?.firstName,
            patient?.lastName,
            formatDate(new Date(patient?.birthDate), "dd.MM.yyyy"),
            appointmentId?.toString(),
            id,
            reason,
          ]
            .filter((field) => field)
            .map((field) => field.toString().toLowerCase())

          return searchTerms.every((searchTerm) => searchableFields.some((field) => field.includes(searchTerm)))
        }),
      })),
    }))
  }, [waitingRoomAppointments, searchValue])

  return appointments
}
